import request from './request'
import { CONSUME_HISTORY_URL } from './config'

/**
 * 获取消费记录（/api/member/consume/history）
 * @param {number} fromIndex 页码（或起始索引，由后端约定）
 * @param {number} pageSize 每页数量
 * 返回 { list, total }，失败返回 { list: [], total: 0 }
 */
export async function getConsumeHistory (fromIndex, pageSize) {
  const params = {}
  if (typeof fromIndex === 'number') params.fromIndex = fromIndex
  if (typeof pageSize === 'number') params.pageSize = pageSize

  try {
    const data = await request.post(CONSUME_HISTORY_URL, params)
    let list = []
    let total = 0

    if (Array.isArray(data)) {
      list = data
    } else if (data) {
      if (Array.isArray(data.list)) {
        list = data.list
      } else if (Array.isArray(data.data)) {
        list = data.data
      }
      if (typeof data.total === 'number') {
        total = data.total
      }
    }

    if (total === 0 && Array.isArray(list)) {
      total = list.length
    }

    return { list, total }
  } catch (err) {
    return { list: [], total: 0 }
  }
}
